export const calculateInnerElements = (sizesArray, ref, countingSize) => {
  var _a;
  if (!ref.current || !((_a = ref.current) === null || _a === void 0 ? void 0 : _a.offsetWidth)) return sizesArray.length;
  const containerWidth = ref.current.offsetWidth;
  let lastContent = 0;
  let innerItems = 0;
  sizesArray.forEach(size => {
    if (size < containerWidth) {
      innerItems++;
      lastContent = size;
    }
  });
  if (countingSize && innerItems < sizesArray.length && !(lastContent + countingSize <= containerWidth)) {
    innerItems--;
  }
  return innerItems;
};